import React, { useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
// import GeneratePdf from './GeneratePdf';
import { get, set, ref, } from 'firebase/database';
import { db, auth, storage } from '../../firebase';
import { styled } from '@mui/system';
import jsPDF from 'jspdf';
import image7 from '../images/image7';
// import image8 from '../images/image8';
// import image9 from '../images/image9';
import image10 from '../images/image10';
import autoTable from 'jspdf-autotable';
import KollektifBold from './KollektifBold';
import Kollektif from './Kollektif';
import { useSelector } from 'react-redux';
import { uploadBytes, getDownloadURL, ref as storageRef } from 'firebase/storage';
import { categories, softSkill, targetJobs } from './VariablesExport';
import { getCollegeName } from '../HomePage/userManagement';

let percentageI = 0, percentageT = 0, totTeamIndivisual = 0, percentageTI = 0;

const GenerateButton = styled('button')({
	marginTop: '20px',
	backgroundColor: '#2560CD',
	padding: '10px 26px',
	color: 'white',
	cursor: 'pointer',
	fontFamily: 'Poppins, sans-serif',
	fontWeight: 500,
	fontSize: '20px',
	borderRadius: '10px',
	'&:hover': {
		background: 'black',
		color: 'white',
		transform: 'scale(1.1)',
	},
});

let couldBeImprovedSkills, needsImprovementSkills, unexploredSkills, opportunitiesSkills, strengthsSkills, exceptionalSkills, workinProgressSkills;
const calculatePercentile = (value, array) => {
	const sortedArray = array.slice().sort((a, b) => a.score - b.score);
	const index = sortedArray.findIndex(item => item.score === value.score);
	return (index + 1) / sortedArray.length * 100;
};

const exceptionalArr = new Set();
const strengthsArr = new Set();
const opportunitiesArr = new Set();
const couldBeImprovedArr = new Set();
const needsImprovementArr = new Set();
const unexploredArr = new Set();
const workinProgressArr = new Set();
// const bulletPoint = '\u2022';

const getLowerType = (score, array) => {
	const percentile = calculatePercentile({ score }, array);

	if (percentile > 70 && percentile <= 100) return 'Work in Progress';
	if (percentile > 40 && percentile <= 70) return 'Could be Improved';
	if (percentile > 10 && percentile <= 40) return 'Needs Improvement';
	return 'Ignored';
};

const getNormalType = (score, array) => {
	const percentile = calculatePercentile({ score }, array);
	if (percentile > 90) return 'Exceptional';
	if (percentile > 75 && percentile <= 90) return 'Strengths';
	if (percentile > 50 && percentile <= 75) return 'Opportunities';
	if (percentile > 25 && percentile <= 50) return 'Work in Progress';
	return 'Could be Improved';
};

const getUpperType = (score, array) => {
	const percentile = calculatePercentile({ score }, array);
	if (percentile > 90 && percentile <= 100) return 'Exceptional';
	if (percentile > 60 && percentile <= 90) return 'Strengths';
	if (percentile > 30 && percentile <= 60) return 'Opportunities';
	return 'Work in Progress';
};

const getColor = (cell) => {
	if (cell === 'Strengths') return 'success';
	if (cell === 'Opportunities') return 'warning';
	if (cell === 'Work in Progress') return 'info';
	if (cell === 'Could be Improved') return 'error';
	if (cell === 'Needs Improvement') return 'action';
	if (cell === 'Ignored') return 'inherit';
	if (cell === 'Exceptional') return 'success';
	return 'error';
}

let res = [];

const addResponsesToArray = async (userUid) => {
	const dateRef = ref(db, `${getCollegeName()}/Assessments/${userUid}/Date Array`);
	const snapshot = await get(dateRef);
	const existingDates = snapshot.val() || {};

	const newTimestamp = new Date().toString();
	const resArray = Object.keys(res).map(question => ({
		question,
		type: res[question].type,
		rank: res[question].rank
	}));
	existingDates[newTimestamp] = resArray;
	set(dateRef, existingDates);
}

const ViewResult = ({ yo, missingElements, competencyScores, leadershipScore }) => {
	const userUid = auth.currentUser.uid;
	const [loading, setLoading] = React.useState(false);
	const { userName, collegeName, counts } = useSelector((state) => state.userDetails);
	let activityCounts = 0, enjoymentPercentage = 0;
	let outcomePercent = 0;
	useEffect(() => {
		const fetchAndInitialize = async () => {
			if (!userUid) return;
			try {
				const activityDetailsRef = ref(db, `${getCollegeName()}/Activities/${userUid}`);
				const snapshot = await get(activityDetailsRef);
				const activityData = snapshot.val();

				if (activityData) {
					let enjoy = 0, outcomeSum = 0;
					activityCounts = Object.keys(activityData).length;

					Object.values(activityData).forEach((activity) => {
						if (activity.enjoyment === 3) {
							enjoy += 1;
						}
						outcomeSum += activity.outcome;
					});

					enjoymentPercentage = (enjoy / activityCounts) * 100;
					outcomePercent = ((outcomeSum / activityCounts) / 5) * 100;
				} else {
					console.warn("No activity data available.");
				}
			} catch (error) {
				console.error('Error fetching and initializing activity data:', error);
			}
		};

		fetchAndInitialize();
	}, [])

	const handlenewpdf = async () => {
		setLoading(true);
		const doc = new jsPDF();
		doc.addFileToVFS('Kollektif-Bold.ttf', KollektifBold);
		doc.addFont('Kollektif-Bold.ttf', 'Kollektif', 'bold');
		doc.addFileToVFS('Kollektif.ttf', Kollektif);
		doc.addFont('Kollektif.ttf', 'Kollektif', 'normal');
		doc.setFillColor(37, 96, 205);
		doc.rect(0, 0, doc.internal.pageSize.width, 40, 'F');
		doc.setFont('Kollektif', 'normal');
		doc.setFontSize(16);
		doc.setTextColor(255, 255, 255)
		doc.text(`Prepared For: ${userName}`, 20, 20)
		doc.text(`College Name: ${collegeName}`, 20, 30, { maxWidth: 190, align: "justify" })
		doc.addImage(image7, 'PNG', 0, 40, 220, 150);
		doc.setFont('Kollektif', 'bold');
		doc.setFontSize(78.3);
		doc.setTextColor(37, 96, 205)
		doc.text("Strengths", 40, 220)
		doc.text("Report", 58, 250)
		doc.setFontSize(16.2);
		doc.setFont('Kollektif', 'normal');
		doc.setTextColor(0, 0, 0)
		doc.text("Vocation", 10, 287)
		doc.setTextColor(255, 0, 0)
		doc.text("IQ", 32.5, 287)
		doc.setTextColor(0, 0, 0)
		const pageWidth = doc.internal.pageSize.width;
		const bgWidth = pageWidth * 0.8;
		const boxWidth = bgWidth * 0.9;
		const boxX = (pageWidth - boxWidth) / 2;
		const rectWidth = 150;
		const rectHeight = 70;
		const rectX = 15;
		const rectY = 60;
		const cornerRadius = 10;
		doc.addPage();
		// doc.addImage(image8, 'PNG', 0, 0, 215, 141);
		doc.setTextColor(37, 96, 205)
		doc.setFont("Kollektif", "bold");
		doc.setFontSize(35);
		doc.text(`Report Overview`, 20, 40);
		doc.setTextColor(0, 0, 0);
		const text3 = `Everyone has a natural talent, developing and applying it leads to excellence and lasting satisfaction.`
		doc.setFont("Kollektif", "normal");
		doc.setFontSize(16);
		doc.text(text3, 20, 60, { maxWidth: 170 })
		doc.setTextColor(37, 96, 205)
		doc.setFont("Kollektif", "bold");
		doc.setFontSize(22);
		doc.text(`Strengths Profile`, 20, 85);
		doc.text("Key Insights", 20, 120);
		doc.text("Introduction VocationIQ", 20, 160);
		doc.text("Test Methodology", 20, 195);
		doc.setTextColor(0, 0, 0);
		const text4 = "Understand yourself better with an outline of your strengths, opportunities and development areas."
		const text6 = "Key insights provide a concise summary of important findings, highlighting strengths, areas for improvement, and actionable recommendations."
		const textIntro = 'The Strengths Analyzer Report highlights your strengths and improvement areas, helping you craft a formula for career success. This can unlock a world of boundless professional opportunities and growth.'
		const textTest = 'The Test employs a distinctive methodology that combinesactivity-based skill assessment with a thorough evaluation of extracurricular activities.'
		doc.setFont("Kollektif", "normal");
		doc.setFontSize(16);
		doc.text(text4, 20, 95, { maxWidth: 180 });
		doc.text(text6, 20, 130, { maxWidth: 180 });
		doc.text(textIntro, 20, 170, { maxWidth: 180 });
		doc.text(textTest, 20, 205, { maxWidth: 180 })
		doc.setTextColor(0, 0, 0);
		doc.line(20, 290, boxX + boxWidth, 290);
		doc.text("02", 190, 291);
		doc.addPage();
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(16);
		doc.setFont("Kollektif", "bold");
		doc.text("Vocation", 163, 20);
		doc.setTextColor(255, 0, 0);
		doc.text("IQ", 187, 20);
		doc.setTextColor(37, 96, 205)
		doc.setFont("Kollektif", "bold");
		doc.setFontSize(35);
		doc.setTextColor(37, 96, 205)
		doc.text("Terminologies & Definitions", 15, 40);
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(22);
		doc.setFont("Kollektif", "normal");
		doc.text("Interpreting the outcomes", 15, 60);
		let currentY1 = 70;
		const leftX1 = 15;
		const maxWidth12 = 180;
		const lineSpacing1 = 6;
		function printDefinition(heading, text) {
			doc.setFont("Kollektif", "bold");
			doc.setFontSize(14);
			doc.setTextColor(37, 96, 205)
			doc.text(heading, leftX1, currentY1, { maxWidth12 });

			doc.setFont("Kollektif", "normal");
			doc.setFontSize(14);
			doc.setTextColor(0, 0, 0)
			currentY1 += lineSpacing1;

			const wrappedText = doc.splitTextToSize(text, maxWidth12);
			doc.text(wrappedText, leftX1, currentY1);
			currentY1 += wrappedText.length * 6 + 8;
		}

		printDefinition(
			"Exceptional Strengths:",
			"These management skills have been consistently demonstrated at an exceptional level by students across activities participated. Students can confidently rely on these skills to excel in roles or areas where they are essential."
		);
		printDefinition(
			"Strengths:",
			"These management skills have been demonstrated consistently well by students across various activities. They are likely to perform effectively in roles or areas where these skills are essential."
		);
		printDefinition(
			"Opportunities:",
			"These management skills are demonstrated to some extent with potential to become strengths. With further application, and development, students could excel in roles that require these abilities."
		);
		printDefinition(
			"Work in Progress:",
			"These management skill are currently being developed and refined by students. Continued practice and experience will likely enhance their proficiency in these areas."
		);
		printDefinition(
			"Could Be Improved:",
			"These skills are functional but not yet at their full potential. Students should focus on strengthening these areas to ensure they meet the demands of more challenging roles."
		);
		printDefinition(
			"Needs Improvement:",
			"These management aspects are currently underdeveloped. Focused effort and targeted learning are required for students to bring these skills up to a satisfactory level."
		);
		printDefinition(
			"Unexplored:",
			"These skills have not been applied so far in any of the activities they have participated in. This is untapped potential that could be valuable in the future"
		);
		doc.setFont("Kollektif", "normal");
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(14);
		doc.line(20, 290, boxX + boxWidth, 290);
		doc.text("03", 190, 291);
		doc.addPage();
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(16);
		doc.setFont("Kollektif", "bold");
		doc.text("Vocation", 163, 20)
		doc.setTextColor(255, 0, 0)
		doc.text("IQ", 187, 20)
		doc.setTextColor(37, 96, 205)
		doc.setFontSize(35);
		doc.text("Strengths Profile", 20, 40);
		const tableData = Object.keys(res).map(question => {
			const { type, rank } = res[question];
			return [question, type, rank];
		});
		autoTable(doc, {
			head: [['Skills', 'Type', 'Rank']],
			body: tableData,
			theme: 'striped',
			tableWidth: 165,
			startY: 55,
			margin: { left: 20 },
			styles: { textColor: [0, 0, 0], lineColor: [255, 255, 255], lineWidth: 0.5, fontSize: 13 },
			columnStyles: { 0: { cellWidth: 'auto' }, 1: { cellWidth: 'auto' }, 2: { cellWidth: 'auto' } },
			headStyles: {
				fillColor: [37, 96, 205],
				textColor: [255, 255, 255],
			},
		});
		doc.line(20, 290, boxX + boxWidth, 290);
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(14);
		doc.setFont("Kollektif", "normal");
		doc.text("04", 190, 291);
		doc.addPage();
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(16);
		doc.setFont("Kollektif", "bold");
		doc.text("Vocation", 163, 20);
		doc.setTextColor(255, 0, 0);
		doc.text("IQ", 187, 20);
		doc.setTextColor(37, 96, 205)
		doc.setFontSize(35);
		doc.text(`Key Insights`, 20, 40);
		doc.setTextColor(0, 0, 0);
		doc.setFont("Kollektif", "normal");
		doc.setFillColor(247, 247, 247);
		doc.roundedRect(rectX, rectY - 15, rectWidth + 20, rectHeight + 135, cornerRadius, cornerRadius, 'F');
		doc.setFontSize(16);
		doc.line(20, 290, boxX + boxWidth, 290);
		let text11;
		let text17 = '', text18 = '', text19 = '';
		let textt, textTI;
		if (counts.countAcademic > counts.countCorporate) {
			textt = "Academic"
		}
		else {
			textt = "Corporate"
		}
		if (counts.countT > counts.countI) {
			textTI = "Team"
		}
		else if (counts.countI > counts.countT) {
			textTI = "Individual"
		}
		else {
			textTI = "Team and individual"
		}
		if (exceptionalSkills.length > 0) {
			text17 = `* You have demonstrated ${exceptionalSkills} as an exceptional strength mostly demonstrated in ${textt} set up and as an ${textTI}.`
		}
		else if (strengthsSkills.length > 0 && exceptionalSkills.length === 0) {
			text17 = `* You have demonstrated ${strengthsSkills} as an exceptional strength mostly demonstrated in ${textt} set up and as an ${textTI}.`
		}
		if (opportunitiesSkills.length > 0) {
			text18 = `* ${opportunitiesSkills} are skills that are demonstrated fairly well and present as an opportunity to convert them into strengths.`
		}
		else if (workinProgressSkills.length > 0 && opportunitiesSkills.length === 0) {
			text18 = `* ${workinProgressSkills} are skills that are demonstrated fairly well and present as an opportunity to convert them into strengths.`
		}
		if (couldBeImprovedSkills.length > 0) {
			text19 = `* The areas that improvement are ${couldBeImprovedSkills} If the target role demands these skills, engage in activities that will help you develop these skills.`
		}
		else if (needsImprovementSkills.length > 0 && couldBeImprovedSkills.length === 0) {
			text19 = `* The areas that improvement are ${needsImprovementSkills} If the target role demands these skills, engage in activities that will help you develop these skills.`
		}
		if (percentageT >= 50) {
			text11 = `Team Player ${Math.round(percentageT)}% the time. Mostly, you enjoy working in a team more than working by yourself.`
		}
		else if (percentageI >= 50) {
			text11 = `Individual Contributor ${Math.round(percentageI)}% the time. Mostly, you enjoy working working by yourself more than in a team.`
		}
		else {
			text11 = `Team Player and Individual Contributor ${Math.round(percentageTI)}% the time. Mostly, you enjoy working both team and by yourself.`
		}

		let text20;
		if (unexploredSkills.length > 0) {
			text20 = `* You have never explored areas such as ${unexploredSkills}. Therefore, you can steer away from the career choices that need these skills.`;
		} else {
			text20 = `* You have explored all the areas in our list, allowing you to get a diverse exposure.`;
		}
		const text15 = `* You have enjoyed the activities ${Math.round(enjoymentPercentage)}% of the time where ${Math.round(outcomePercent)}% of the time the outcomes have been excellent.`
		const text16 = `* Overall you have participated in ${activityCounts} activities and have been a ${text11}`
		const maxWidth = 160;
		let combinedText = '';
		if (text17) combinedText += `${text17}\n\n`;
		if (text18) combinedText += `${text18}\n\n`;
		if (text19) combinedText += `${text19}\n\n`;
		if (text20) combinedText += `${text20}\n\n`;
		if (text15) combinedText += `${text15}\n\n`;
		if (text16) combinedText += `${text16}`;
		const lines = doc.splitTextToSize(combinedText, maxWidth);
		let startY1 = 57;
		const lineHeight1 = 7;
		doc.setTextColor(0, 0, 0);
		doc.setFont("Kollektif", "normal");
		doc.setFontSize(14);
		lines.forEach((line, index) => {
			doc.text(line, 20, startY1 + (index * lineHeight1));
		});
		doc.text("05", 190, 291);
		// doc.addPage();
		// doc.setTextColor(0, 0, 0);
		// doc.setFontSize(16);
		// doc.setFont("Kollektif", "bold");
		// doc.text("Vocation", 163, 20);
		// doc.setTextColor(255, 0, 0);
		// doc.text("IQ", 187, 20);
		// doc.setTextColor(37, 96, 205)
		// doc.setFontSize(25);
		// doc.text(`Category Scores`, 20, 32);
		// doc.setTextColor(0, 0, 0);
		// doc.setFont("Kollektif", "normal");
		// doc.setFontSize(14);
		// doc.addImage(image9, 'PNG', 10, 35, 180, 105);
		// doc.text("Above chart inidcates your effort distribution and the categories where you have demonstrated better.", 20, 143, { maxWidth: 180, align: "justify" });
		// doc.setFontSize(11);
		// doc.text(`- ${categories.percentageManagerialandAdministrative}%`, 168, 49.6)
		// doc.text(`- ${categories.percentageProcessandPlanning}%`, 161, 67.6)
		// doc.text(`- ${categories.percentageCreative}%`, 155, 86.3)
		// doc.text(`- ${categories.percentagePeople}%`, 148, 106.8)
		// doc.text(`- ${categories.percentageNumerical}%`, 155, 126);
		// doc.setTextColor(37, 96, 205);
		// doc.setTextColor(0, 0, 0);
		// doc.line(20, 290, boxX + boxWidth, 290);
		// doc.text("05", 190, 291);
		// Add a new page
		doc.addPage();
		doc.setFont("Kollektif", "bold");
		doc.setFontSize(16);
		doc.setTextColor(0, 0, 0);
		doc.text("Vocation", 163, 20);
		doc.setTextColor(255, 0, 0);
		doc.text("IQ", 187, 20);

		doc.setFontSize(35);
		doc.setTextColor(37, 96, 205)
		doc.text("Strengths & Decision Making", 15, 40);
		doc.setFontSize(22);
		doc.setTextColor(0, 0, 0);
		doc.setFont("Kollektif", "normal");
		doc.text("Application of the outcomes", 15, 60);

		let currentY = 70;
		const leftX = 15;
		const maxWidth1 = 180;
		const lineSpacing = 6;

		function printDefinition1(heading, text) {
			doc.setFont("Kollektif", "bold");
			doc.setFontSize(14);
			doc.setTextColor(37, 96, 205)
			doc.text(heading, leftX, currentY, { maxWidth: maxWidth1 });

			doc.setFont("Kollektif", "normal");
			doc.setFontSize(14);
			doc.setTextColor(0, 0, 0)
			currentY += lineSpacing;

			const wrappedText = doc.splitTextToSize(text, maxWidth1);
			doc.text(wrappedText, leftX, currentY);
			currentY += wrappedText.length * 6 + 8;
		}

		printDefinition1("Forming a team:", "By understanding both your own strengths profile and those of others, you can build a well-balanced team with complementary skills. This allows you to leverage strengths effectively, address weaknesses as needed, and enhance collaboration for projects, internships, event planning, and other team-based activities.");
		printDefinition1("Resume & Interview:", "A resume showcases what you’ve done, but does it reveal your true strengths? Highlighting your strengths in your resume and interviews not only demonstrates what you're capable of but also boosts your chances of landing your dream job. Plus, it helps you confidently tackle tough questions about the weaknesses during interviews.");
		printDefinition1("Entreprenuership:", "Having the right team with complimentary skills needed for your start-up can be crucial. Strengths profile of your team can reveal a lot about where your potential lies. With the overall comptency scores, you will know what areas you need to work on simulatneously while building your start-up.");
		printDefinition1("Deciding on Course Specialization:", "A combination of Exceptional skills, Strengths & Opportunities can be taken into consideration to make the right choice of specialization.");
		printDefinition1("Preparing and choosing the most suitable Jobs or Internships:", "Choosing the Right Job or Internship: Your strengths help you identify roles where you can excel and make an immediate impact. Weaknesses highlight skill gaps to work on for growth. Playing to your strengths ensures a confident start in your career.");
		printDefinition1("Career Transitioning:", "Identifying the right strengths as transferable skills can guide smooth career transitions and open new opportunities.");
		doc.setFont("Kollektif", "normal");
		doc.setTextColor(0, 0, 0);
		doc.setFontSize(14);
		doc.line(20, 290, boxX + boxWidth, 290);
		doc.text("06", 190, 291);
		doc.addPage();
		doc.setFont("Kollektif", "bold");
		doc.setFontSize(16);
		doc.setTextColor(0, 0, 0);
		doc.text("Vocation", 163, 20);
		doc.setTextColor(255, 0, 0);
		doc.text("IQ", 187, 20);
		doc.setTextColor(0, 0, 0);
		doc.setTextColor(37, 96, 205)
		doc.setFontSize(22);
		doc.text(`Career Readiness Competency`, 15, 30);
		doc.setTextColor(0, 0, 0)
		const competencyCategories = {
			"Relationship Management": ["External Interactions", "Internal Interactions", "Cross Cultural Engagements"],
			"Leadership & Influence": ["Leadership", "Dynamic Presence", "Critical Thinking and Problem Solving"],
			"Quantitative and Analytical": ["Numerical and Quantitative Aptitude", "Analytics, Research and Insights", "Monitoring, Inspecting and Testing"],
			"Strategic Thinking & Execution": ["Negotiations and Deal Making", "Resource Management", "Project Management"],
			"Innovation & Creativity": ["Creation and Innovation", "Design and Visualization", "Marketing and Promotions"],
			"Operational Excellence": ["Operations and Process Excellence", "Administration", "Recruitment and Support"],
			"Self Development & Ethical Leadership": ["Subject Matter Expertise", "Social Initiatives and Impact", "Self Management and Development"]
		};
		const competencyData = [];

		Object.keys(competencyCategories).forEach(category => {
			competencyData.push([
				{
					content: category,
					colSpan: 3,
					styles: {
						halign: 'center',
						fillColor: [37, 96, 205],
						textColor: [255, 255, 255],
						fontStyle: 'bold'
					}
				}
			]);

			competencyCategories[category].forEach(skill => {
				const skillType = res && res[skill] ? res[skill].type : "";
				competencyData.push([
					"",
					skill,
					skillType
				]);
			});
		});
		doc.setFillColor(247, 247, 247);
		doc.roundedRect(rectX, rectY, rectWidth + 40, rectHeight, cornerRadius, cornerRadius, 'F');
		doc.autoTable({
			startY: 40,
			theme: 'striped',
			margin: { left: 20 },
			body: competencyData,
			styles: {
				textColor: [0, 0, 0],
				lineColor: [255, 255, 255],
				lineWidth: 0.5,
				fontSize: 10,
				valign: 'middle'
			},
			columnStyles: {
				0: { cellWidth: 'auto' },
				1: { cellWidth: 'auto' },
				2: { cellWidth: 'auto' }
			}
		});
		doc.setFont("Kollektif", "normal");
		doc.setFontSize(16);
		doc.line(20, 290, boxX + boxWidth, 290);
		doc.text("07", 190, 291);
		// 		doc.addPage();
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 163, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 187, 20);
		// 		doc.setFontSize(35);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205)
		// 		doc.text(`Career Implication`, 10, 30);
		// 		doc.setFontSize(22);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205)
		// 		doc.text("External Interactions", 15, 45)
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setFontSize(14);
		// 		const content2 = `External interaction refers to communication, collaboration, or activities that take place outside the boundaries of a particular organization, institution, or community. This can involve engaging with external entities such as other organizations, industries, academic institutions, or the public. The term is often used in academic or research contexts to describe collaborations or partnerships with external parties, which can enhance the scope, impact, and resources of the internal work being done.`;
		// 		doc.text(content2, 15, 55, { maxWidth: 185, align: "justify" })
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205)
		// 		doc.text("Key Aspects of External Interactions:", 15, 93);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content3 = `
		// ${bulletPoint}  Networking: Engaging in External interactions requires effective networking. This involves attending events, conferences, seminars, and industry gatherings to connect with professionals from diverse backgrounds.

		// ${bulletPoint}  Relationship Building: Developing strong relationships with clients, customers, suppliers, partners, and even competitors can lead to collaborations, referrals, and shared successes.

		// ${bulletPoint}  Community Engagement: External interactions can extend to community involvement and social responsibility efforts. Participating in community events and initiatives can enhance the reputation of both individuals and organizations.

		// ${bulletPoint}  Business Development: This skill is particularly relevant in roles that involve expanding the reach of an organization. Building relationships with potential clients and partners can contribute to business growth.

		// ${bulletPoint}  Collaboration: Collaborating across organizational boundaries can lead to innovative projects and shared resources. Cross-industry collaborations can lead to unique solutions and approaches.
		// `;
		// 		doc.setFontSize(14);
		// 		doc.text(content3, 15, 98, { maxWidth: 185, align: "justify" });
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 215)
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content4 = `
		// For MBA students who possess strength in External interactions, several entry-level roles can provide opportunities to harness and further develop this skill:

		// ${bulletPoint}  Business Development Associate: Engaging with potential clients and partners to explore business opportunities and collaborations.

		// ${bulletPoint}  Account Executive: Managing relationships with existing clients and ensuring their needs are met, often involving regular client interactions.

		// ${bulletPoint}  Vendor Relationship Coordinator: Building and maintaining positive relationships with suppliers and vendors to ensure a smooth supply chain.
		// `;
		// 		doc.setFontSize(14);
		// 		doc.text(content4, 15, 220, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("05", 190, 291);
		// 		doc.addPage();
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 163, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 187, 20);
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 30)
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content4b = `
		// ${bulletPoint}  Marketing & Public Relations: Assisting in managing the organization's external communications, including media interactions and community engagement.

		// ${bulletPoint}  Community Outreach Coordinator: Engaging with the local community, initiating partnerships, and organizing events to promote the organization's presence.

		// ${bulletPoint}  Event Coordinator: Planning and executing events, conferences, and seminars that bring together professionals from various industries.
		// `;
		// 		doc.setFontSize(14);
		// 		doc.text(content4b, 15, 35, { maxWidth: 185, align: "justify" });
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Developing External Interactions:", 15, 90)
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content4t = `
		// ${bulletPoint}  Opportunity Expansion: External interactions open doors to new opportunities, whether it's potential business partnerships, collaborations, or career advancements.

		// ${bulletPoint}  Knowledge Exchange: Engaging with professionals from diverse fields exposes you to different perspectives and insights that can enrich your own understanding.

		// ${bulletPoint}  Resource Sharing: Collaborating with external stakeholders can lead to resource sharing, cost optimization, and mutual growth.

		// ${bulletPoint}  Enhanced Reputation: Building a strong network and engaging in External interactions can enhance your personal and professional reputation within your industry.

		// ${bulletPoint}  Innovation: Interacting with individuals from various backgrounds can spark creative ideas and innovative solutions to challenges.
		// `;
		// 		doc.setFontSize(14);
		// 		doc.text(content4t, 15, 95, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22)
		// 		doc.text("Internal Interactions", 10, 193);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content6 = `Internal interactions refer to the exchanges and collaborations that occur within the boundaries of your organization or institution. These interactions are vital for teamwork, information sharing, and fostering a cohesive work culture.`;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.text(content6, 15, 203, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205)
		// 		doc.text("Key Aspects of Internal Interactions:", 15, 223);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content7tt = `
		// ${bulletPoint}  Communication: Effective communication with team members and leadership is key to ensuring everyone is aligned.

		// ${bulletPoint}  Teamwork: Working closely with colleagues across departments ensures smooth project execution and knowledge sharing.

		// ${bulletPoint}  Problem-Solving: Many challenges in the workplace require input from various perspectives. Intra mural interactions allow team members to collectively address problems and find innovative solutions.
		// `;
		// 		doc.text(content7tt, 15, 228, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("06", 190, 291);
		// 		doc.addPage();
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 163, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 187, 20);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content7bt = `
		// ${bulletPoint}  Knowledge Sharing: Employees possess diverse skills and expertise. Sharing knowledge within the organization helps individuals learn from each other and contributes to professional development.

		// ${bulletPoint}  Conflict Resolution: Managing and resolving internal conflicts constructively strengthens relationships and work outcomes.
		// `;
		// 		doc.text(content7bt, 15, 25, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.text("Applicable Roles:", 15, 70);
		// 		doc.setFontSize(14);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content8 = `
		// For MBA students who excel in Internal interactions, various entry-level roles provide opportunities to leverage and further develop this skill:

		// ${bulletPoint}  Team Leader: Coordinating efforts within your team to achieve common goals.

		// ${bulletPoint}  Project Coordinator: Ensuring effective internal communication and project execution.

		// ${bulletPoint}  Human Resources Associate: Fostering a healthy work environment through internal communication and employee engagement.
		// `;
		// 		doc.text(content8, 15, 75, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.text("Benefits of Developing Internal Interactions:", 15, 140);
		// 		doc.setFontSize(14);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content8t2 = `
		// ${bulletPoint}  Improved Team Dynamics: Strong internal relationships lead to more productive and harmonious team interactions.

		// ${bulletPoint}  Efficiency: Effective Internal collaboration streamlines processes and improves workflow.

		// ${bulletPoint}  Career Growth: Internal networking and relationship-building can lead to new opportunities within your organization.
		// `;
		// 		doc.text(content8t2, 15, 145, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205)
		// 		doc.setFontSize(22);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text(`Negotiations and Deal Making`, 10, 205, { maxWidth: 185, align: "justify" })
		// 		doc.setFont("Kollektif", "normal");
		// 		const content11 = `
		// Negotiations and Deal Making involve creating interest in products or services, securing deals, and negotiating favorable terms. These skills are essential in roles that involve business development, sales, and partnership management.
		// `;
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content11, 15, 210, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text(`Key Aspects of Negotiations and Deal Making:`, 15, 235, { maxWidth: 185, align: "justify" })
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content12 = `
		// ${bulletPoint}  Strategic Communication: Persuasively communicating the value proposition to potential clients or partners.

		// ${bulletPoint}  Negotiation Tactics: Utilizing effective negotiation strategies to secure deals with favourable terms.

		// ${bulletPoint}  Market Understanding: Knowing your audience and market to generate demand and tailor your approach.
		// `;
		// 		doc.text(content12, 15, 240, { maxWidth: 185, align: "justify" });
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("07", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 25)
		// 		const content17 = `
		// ${bulletPoint}  Business Development Manager: Identifying new business opportunities and negotiating contracts.

		// ${bulletPoint}  Sales Executive: Driving sales through demand generation and deal closure.

		// ${bulletPoint}  Account Manager: Managing client relationships and negotiating renewals and upsells.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content17, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Negotiations and Deal Making:", 15, 80, { maxWidth: 185, align: "justify" })
		// 		const content17t = `
		// ${bulletPoint}  Revenue Growth: Effective demand generation and deal-making directly contribute to revenue growth.

		// ${bulletPoint}  Stronger Partnerships: Negotiating beneficial terms strengthens long-term partnerships.

		// ${bulletPoint}  Professional Leverage: Strong negotiation skills give you an edge in securing favourable outcomes.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content17t, 15, 90, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Numerical & Quantitative Aptitutde:", 10, 150)
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content13 = `
		// Numerical & Quantitative Aptitutde involves the application of mathematical techniques to analyze data, solve problems, and make informed decisions. This skill is crucial in areas such as finance, operations, and strategy, where data-driven decision-making is key.
		// `;
		// 		doc.text(content13, 15, 155, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Numerical & Quantitative Aptitutde:", 15, 187);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content14 = `
		// ${bulletPoint}  Data Interpretation: Analyzing quantitative data to extract insights and trends.

		// ${bulletPoint}  Problem-Solving: Using mathematical techniques to solve complex problems.

		// ${bulletPoint}  Decision-Making: Applying numerical insights to inform business decisions.
		// `;
		// 		doc.text(content14, 15, 192, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 232)
		// 		const content120 = `
		// ${bulletPoint}  Financial Analyst: Analyzing financial data to support investment and business decisions.

		// ${bulletPoint}  Data Analyst: Interpreting data to provide actionable insights for business improvement.

		// ${bulletPoint}  Operations Analyst: Using numerical data to optimize operational processes.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content120, 15, 237, { maxWidth: 185, align: "justify" });
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("08", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Developing Numerical & Quantitative Aptitutde:", 15, 30)
		// 		const content170 = `
		// ${bulletPoint}  Informed Decision-Making: Numerical & Quantitative Aptitutde supports more accurate and effective decisions.

		// ${bulletPoint}  Career Versatility: Strong numerical skills are valuable in a wide range of industries.

		// ${bulletPoint}  Efficiency Gains: Data-driven decisions lead to greater efficiency and resource optimization.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content170, 15, 35, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Resource Management:", 10, 90)
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content20 = `
		// Resource management is the process of efficiently and effectively allocating and utilizing available resources—whether human, financial, or material—to achieve organizational goals.
		// `;
		// 		doc.text(content20, 15, 95, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Resource Management:", 15, 120);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content21 = `
		// ${bulletPoint}  Budgeting: Managing financial resources to ensure the project stays within budget.

		// ${bulletPoint}  Time Management: Allocating time effectively to meet deadlines and ensure efficient workflow.

		// ${bulletPoint}  Human Resource Allocation: Ensuring the right people are working on the right tasks based on their strengths and availability.
		// `;
		// 		doc.text(content21, 15, 125, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 175)
		// 		const content22 = `
		// ${bulletPoint}  Project Manager: Overseeing resource allocation to ensure project success.

		// ${bulletPoint}  Operations Manager: Managing day-to-day operations to optimize resources.

		// ${bulletPoint}  Financial Analyst: Ensuring financial resources are managed effectively to support organizational goals.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content22, 15, 180, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Developing Resource Management:", 15, 223)
		// 		const content23 = `
		// ${bulletPoint}  Optimized Operations: Effective resource management leads to more streamlined operations and cost savings.

		// ${bulletPoint}  Increased Productivity: Efficient allocation of resources enhances productivity and output.

		// ${bulletPoint}  Strategic Growth: Proper resource management supports long-term growth and sustainability.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content23, 15, 228, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("09", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text(`Analytics, Market Research & Insights:`, 10, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content24 = `Analytics, market research, and insights involve collecting, processing, and interpreting data to make informed decisions that drive organizational success and customer satisfaction.`;
		// 		doc.text(content24, 15, 40, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text(`Key Aspects of Analytics, Market Research & Insights:`, 15, 60, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content25 = `
		// ${bulletPoint}  Data Collection:  Gathering quantitative and qualitative data through surveys, interviews, and digital platforms to understand market trends and customer behavior.

		// ${bulletPoint}  Data Analysis: Utilizing statistical tools, AI, and machine learning to extract meaningful insights and patterns from raw data.

		// ${bulletPoint}  Market Segmentation: Dividing the target market into segments based on demographics, behavior, and preferences to tailor strategies.

		// ${bulletPoint}  Competitive Analysis: Monitoring competitors to identify opportunities, threats, and best practices in the industry.

		// ${bulletPoint}  Forecasting and Trends Analysis: Predicting market changes and customer needs to stay ahead of industry trends.
		// `;
		// 		doc.text(content25, 15, 65, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 155)
		// 		const content26 = `
		// ${bulletPoint}  Data Analyst: Interpreting and presenting data to identify trends and actionable insights.

		// ${bulletPoint}  Market Research Analyst: Conducting market studies to understand customer needs, preferences, and competitive landscapes.

		// ${bulletPoint}  Business Intelligence Specialist: Developing dashboards and reports for decision-making based on data-driven insights.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content26, 15, 160, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Analytics, Market Research & Insights:", 15, 215, { maxWidth: 185, align: "justify" })
		// 		const content27 = `
		// ${bulletPoint}  Enhanced Decision-Making: Data-driven insights lead to better strategic and operational decisions.

		// ${bulletPoint}  Customer-Centric Strategies: Understanding customer behavior and preferences helps develop targeted marketing campaigns and products.

		// ${bulletPoint}  Market Competitiveness: Staying informed about market trends and competitors ensures agility and innovation.

		// ${bulletPoint}  Profitability: Identifying high-potential opportunities and reducing risks improves financial outcomes.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content27, 15, 220, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("10", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content29t = `
		// ${bulletPoint}  Future Readiness: Anticipating trends supports sustainable growth and innovation.

		// By building capabilities in analytics, market research, and insights, organizations can better align their offerings with customer needs and adapt effectively to changing market conditions.
		// `;
		// 		doc.text(content29t, 15, 25, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Creation and Innovation:", 10, 65);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content28 = `Creation and Innovation involve generating novel ideas, approaches, and solutions to address challenges or seize opportunities. These qualities are critical in dynamic business environments where continuous improvement and adaptability are key to long-term success.`;
		// 		doc.text(content28, 15, 75, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Creation and Innovation", 15, 105);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content29 = `
		// ${bulletPoint}  Idea Generation: Coming up with new, original concepts that can enhance products, services, or processes.

		// ${bulletPoint}  Problem-Solving: Applying creative thinking to devise solutions to complex problems.

		// ${bulletPoint}  Adaptability: Being open to change and willing to experiment with new approaches.
		// 		`;
		// 		doc.text(content29, 15, 110, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 160)
		// 		const content30 = `
		// ${bulletPoint}  Product Development Manager: Leading the creation of new products or improving existing ones.

		// ${bulletPoint}  Marketing Specialist: Developing creative campaigns that capture consumer attention.

		// ${bulletPoint}  Innovation Consultant: Advising organizations on innovative strategies to drive growth.
		// 		`;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content30, 15, 165, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text(`Benefits of Creation and Innovation:`, 15, 220, { maxWidth: 185, align: "justify" })
		// 		const content31 = `
		// ${bulletPoint}  Competitive Edge: Creative solutions can differentiate your organization in a crowded marketplace.

		// ${bulletPoint}  Increased Engagement: Innovation encourages a culture of curiosity and active participation.

		// ${bulletPoint}  Growth Opportunities: Innovating within your role can lead to personal and organizational growth.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content31, 15, 225, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("11", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Subject Matter Expertise:", 10, 25);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content32 = `Subject Matter Expertise refers to a deep understanding and advanced knowledge of a specific field, industry, or subject area. As an SME, you are seen as a go-to resource for advice, insights, and problem-solving related to your field of expertise. This expertise is often cultivated through years of study, hands-on experience, and continuous learning.`;
		// 		doc.text(content32, 15, 35, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Subject Matter Expertise:", 15, 70);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content33 = `
		// ${bulletPoint}  In-Depth Knowledge: You possess comprehensive and detailed knowledge about your specific area, making you a credible authority.

		// ${bulletPoint}  Problem-Solving: SMEs are often sought after to troubleshoot, diagnose issues, and provide effective solutions.

		// ${bulletPoint}  Thought Leadership: Sharing your expertise through writing, speaking, and mentoring helps shape industry trends and educate others.

		// ${bulletPoint}  Consultation: SMEs often consult with other professionals or teams, offering valuable input to drive projects or business initiatives forward.
		// 		`;
		// 		doc.text(content33, 15, 75, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 150)
		// 		const content34 = `
		// ${bulletPoint}  Consultant: Offering advice and solutions based on your specialized knowledge.

		// ${bulletPoint}  Analyst: Using your expertise to analyze and interpret data within your industry.

		// ${bulletPoint}  Subject Matter Expert: Engaging with project teams to provide expert guidance in specific areas.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content34, 15, 155, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Subject Matter Expertise:", 15, 200)
		// 		const content35 = `
		// ${bulletPoint}  Increased Credibility: Being an SME enhances your reputation as an expert in your field.

		// ${bulletPoint}  Career Advancement: SMEs are often positioned for leadership and advanced roles.

		// ${bulletPoint}  Impact: You have the opportunity to shape outcomes and strategies in your area of specialization.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content35, 15, 205, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("12", 190, 291);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Operations & Process Excellence:", 10, 25);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content36 = `Operations & Process Excellence involves streamlining business processes to improve efficiency, quality, and performance. This skill is critical for ensuring that organizations operate smoothly and continuously improve their workflows.`;
		// 		doc.text(content36, 15, 35, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Operations & Process Excellence:", 15, 60);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content37 = `
		// ${bulletPoint}  Process Optimization: Identifying and eliminating inefficiencies in business processes.

		// ${bulletPoint}  Continuous Improvement: Implementing ongoing improvements to enhance productivity.

		// ${bulletPoint}  Quality Management: Ensuring that processes consistently meet or exceed quality standards.
		// 		`;
		// 		doc.text(content37, 15, 65, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 120)
		// 		const content38 = `
		// ${bulletPoint}  Process Improvement Specialist: Analyzing and optimizing business processes to drive efficiency.

		// ${bulletPoint}  Operations Manager: Overseeing the execution of efficient and high-quality operational processes.

		// ${bulletPoint}  Quality Assurance Manager: Ensuring that business processes adhere to quality standards.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content38, 15, 125, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Operations & Process Excellence:", 15, 180)
		// 		const content39 = `
		// ${bulletPoint}  Increased Efficiency: Optimizing processes leads to cost savings and productivity gains.

		// ${bulletPoint}  Higher Quality: Operations & Process Excellence improves the quality of products and services.

		// ${bulletPoint}  Scalability: Efficient processes allow organizations to scale more effectively.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content39, 15, 185, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Marketing and Promotions:", 10, 240);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content40 = `Marketing and Promotions involve creating strategies to promote products, services, or brands, with the goal of attracting and retaining customers. Strong marketing skills are essential in any business to drive growth and build brand awareness.`;
		// 		doc.text(content40, 15, 250, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("13", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Marketing and Promotions:", 15, 25);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content41 = `
		// ${bulletPoint}  Strategic Planning: Developing marketing strategies that align with business goals.

		// ${bulletPoint}  Branding: Establishing and maintaining a strong brand identity.

		// ${bulletPoint}  Campaign Execution: Implementing marketing campaigns across various channels.
		// `;
		// 		doc.text(content41, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold")
		// 		doc.text("Applicable Roles:", 15, 70)
		// 		const content42 = `
		// ${bulletPoint}  Marketing Coordinator: Assisting in the development and execution of marketing campaigns.

		// ${bulletPoint}  Brand Manager: Overseeing the development and maintenance of a brand’s identity.

		// ${bulletPoint}  Social Media Manager: Managing promotional activities across social media platforms.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content42, 15, 75, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Marketing and Promotions:", 15, 130)
		// 		const content43 = `
		// ${bulletPoint}  Brand Visibility: Effective marketing increases brand visibility and awareness.

		// ${bulletPoint}  Customer Engagement: Marketing campaigns engage customers and foster brand loyalty.

		// ${bulletPoint}  Revenue Growth: Strategic marketing directly impacts sales and revenue.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content43, 15, 135, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Critical Thinking and Problem Solving:", 10, 180);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content44 = `Critical Thinking and Problem Solving involves identifying challenges and developing effective solutions. It is a key competency in almost every role, as organizations face a variety of issues that require creative, practical solutions.`;
		// 		doc.text(content44, 15, 190, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Critical Thinking and Problem Solving:", 15, 210);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content45 = `
		// ${bulletPoint}  Critical Thinking: Analysing situations logically to identify the root causes of problems.

		// ${bulletPoint}  Creativity: Developing innovative solutions that address challenges effectively.

		// ${bulletPoint}  Decision-Making: Making informed decisions based on the best available information.
		// 		`;
		// 		doc.text(content45, 15, 215, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("14", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.text("Applicable Roles:", 15, 25)
		// 		const content46 = `
		// ${bulletPoint}  Business Analyst: Identifying organizational problems and developing strategic solutions.

		// ${bulletPoint}  Consultant: Helping clients solve complex business challenges.

		// ${bulletPoint}  Operations Manager: Resolving operational issues to improve efficiency and productivity.
		// 		`;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content46, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Critical Thinking and Problem Solving:", 15, 80)
		// 		const content47 = `
		// ${bulletPoint}  Versatility: Strong problem-solving skills are valuable across industries and roles.

		// ${bulletPoint}  Innovation: Problem-solving often leads to innovative solutions that improve outcomes.

		// ${bulletPoint}  Leadership Potential: Effective problem solvers are often seen as strong leaders and decision-makers.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content47, 15, 85, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Project Management:", 10, 135);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content48 = `
		// Project Management involves the planning, execution, and completion of projects within a specific timeframe, scope, and budget. Effective project management requires strong organizational, leadership, and communication skills to guide teams toward achieving objectives.
		// `;
		// 		doc.text(content48, 15, 140, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Project Management:", 15, 170);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content49 = `
		// ${bulletPoint}  Planning and Organization: Developing a clear project plan that outlines tasks, timelines, and resources.

		// ${bulletPoint}  Team Coordination: Leading and coordinating team members to ensure tasks are completed efficiently.

		// ${bulletPoint}  Risk Management: Identifying potential risks and developing contingency plans to mitigate them.
		// `;
		// 		doc.text(content49, 15, 175, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.text("Applicable Roles:", 15, 230)
		// 		const content50 = `
		// ${bulletPoint}  Project Manager: Overseeing projects from inception to completion, ensuring they meet deadlines and budgets.

		// ${bulletPoint}  Program Manager: Managing multiple related projects to achieve broader business goals.

		// ${bulletPoint}  Operations Manager: Coordinating and streamlining operations across projects to improve efficiency.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content50, 15, 235, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("15", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Project Management:", 15, 25)
		// 		const content51 = `
		// ${bulletPoint}  Increased Efficiency: Effective project management reduces delays and ensures smooth execution.

		// ${bulletPoint}  Career Progression: Strong project management skills are highly sought after in many industries.

		// ${bulletPoint}  Goal Achievement: Proper project management ensures the successful completion of key objectives.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content51, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Recruitment and Support:", 10, 85);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content52 = `
		// Recruitment and Support involve ensuring that an organization operates within legal and ethical boundaries. These skills are vital for maintaining the integrity and sustainability of business operations.
		// `;
		// 		doc.text(content52, 15, 90, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Recruitment and Support:", 15, 115);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content53 = `
		// ${bulletPoint}  Regulatory Knowledge: Staying informed about the laws and regulations that impact your industry.

		// ${bulletPoint}  Ethical Decision-Making: Ensuring that business practices align with legal and ethical standards.

		// ${bulletPoint}  Risk Management: Identifying and mitigating risks related to non-compliance.
		// `;
		// 		doc.text(content53, 15, 120, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.text("Applicable Roles:", 15, 170)
		// 		const content54 = `
		// ${bulletPoint}  Compliance Officer: Overseeing compliance with legal and regulatory requirements.

		// ${bulletPoint}  Risk Manager: Identifying and mitigating risks related to Recruitment and Support.

		// ${bulletPoint}  Corporate Governance Analyst: Evaluating corporate governance structures and practices.
		// 		`;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content54, 15, 175, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Recruitment and Support:", 15, 230)
		// 		const content55 = `
		// ${bulletPoint}  Legal Protection: Strong Recruitment and Support practices protect organizations from legal risks.

		// ${bulletPoint}  Reputation Management: Compliance with laws and regulations enhances the organization’s reputation.

		// ${bulletPoint}  Sustainability: Proper governance ensures the long-term sustainability of the business.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content55, 15, 235, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("16", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Administration:", 10, 25);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content56 = `
		// Administration refers to the management of daily operations within an organization, ensuring that business functions run smoothly. Administrative skills are vital for maintaining order, ensuring compliance, and supporting overall organizational efficiency.
		// `;
		// 		doc.text(content56, 15, 35, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Administration:", 15, 65);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content57 = `
		// ${bulletPoint}  Organization: Maintaining orderly records, schedules, and communication systems.

		// ${bulletPoint}  Compliance: Ensuring that all activities adhere to organizational policies and legal requirements.

		// ${bulletPoint}  Support Services: Providing essential support to other departments, such as HR, finance, and operations.
		// `;
		// 		doc.text(content57, 15, 70, { maxWidth: 185, align: "justify" });

		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.text("Applicable Roles:", 15, 120)
		// 		const content58 = `
		// ${bulletPoint}  Administrative Assistant: Handling day-to-day tasks to keep the organization running smoothly.

		// ${bulletPoint}  Office Manager: Overseeing the administrative functions within an office environment.

		// ${bulletPoint}  Executive Assistant: Supporting top executives with scheduling, communication, and task management.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content58, 15, 125, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Administration:", 15, 180)
		// 		const content59 = `
		// ${bulletPoint}  Operational Efficiency: Good administration ensures that all business processes are streamlined and effective.

		// ${bulletPoint}  Career Foundation: Administrative skills serve as a foundation for more advanced managerial roles.

		// ${bulletPoint}  Problem Prevention: Proper administrative oversight can prevent issues before they arise.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content59, 15, 185, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Leadership:", 10, 240);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content60 = `
		// Leadership involves guiding and inspiring others to achieve a common goal. Strong leadership is characterized by the ability to motivate, delegate, and make strategic decisions that benefit the team and the organization.
		// `;
		// 		doc.text(content60, 15, 245, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("17", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Leadership:", 15, 25);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content61 = `
		// ${bulletPoint}  Vision: Creating and communicating a clear vision for the future that motivates and aligns your team.

		// ${bulletPoint}  Empowerment: Encouraging team members to take ownership and develop their skills.

		// ${bulletPoint}  Decision-Making: Making informed and timely decisions that guide your team towards success.
		// `;
		// 		doc.text(content61, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 85)
		// 		const content62 = `
		// ${bulletPoint}  Administrative Assistant: Handling day-to-day tasks to keep the organization running smoothly.

		// ${bulletPoint}  Office Manager: Overseeing the administrative functions within an office environment.

		// ${bulletPoint}  Executive Assistant: Supporting top executives with scheduling, communication, and task management.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content62, 15, 90, { maxWidth: 185, align: "justify" });

		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Leadership:", 15, 145)
		// 		const content63 = `
		// ${bulletPoint}  Influence: Strong leadership enhances your ability to influence others and drive change.

		// ${bulletPoint}  Career Growth: Leadership skills are often a key factor in career progression and advancement.

		// ${bulletPoint}  Team Success: Effective leadership creates a high-performing team that achieves consistent results.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content63, 15, 150, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Dynamic Presence:", 10, 205);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content64 = `
		// Dynamic Presence refers to direct, hands-on involvement in operations, projects, or initiatives, often in real-world settings. This skill is crucial in roles that require active participation outside the office, such as fieldwork, sales, or community outreach.
		// `;
		// 		doc.text(content64, 15, 210, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Dynamic Presence:", 15, 240);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content65 = `
		// ${bulletPoint}  Hands-On Work: Engaging directly with the physical or operational aspects of a project.

		// ${bulletPoint}  Real-Time Critical Thinking and Problem Solving: Addressing issues as they arise in the field.

		// ${bulletPoint}  Stakeholder Interaction: Building relationships with individuals and communities directly impacted by your work.
		// `;
		// 		doc.text(content65, 15, 245, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("18", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.text("Applicable Roles:", 15, 25)
		// 		const content66 = `
		// ${bulletPoint}  Field Sales Representative: Engaging with customers and clients in various locations to drive sales.

		// ${bulletPoint}  Community Outreach Coordinator: Working directly with communities to implement programs or initiatives.

		// ${bulletPoint}  Operations Manager: Overseeing day-to-day operations in the field.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content66, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Dynamic Presence:", 15, 80)
		// 		const content67 = `
		// ${bulletPoint}  Real-World Experience: Direct engagement provides practical insights that can’t be gained from a desk.

		// ${bulletPoint}  Immediate Feedback: Working in the field allows for quick adjustments and improvements.

		// ${bulletPoint}  Enhanced Relationships: Direct interaction with stakeholders fosters trust and collaboration.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content67, 15, 85, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Design & Visualization:", 10, 140);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content68 = `
		// Design & Visualization involve the ability to create and communicate ideas visually. These skills are crucial in fields such as marketing, product development, and creative industries, where conveying concepts through visuals can enhance understanding and engagement.
		// `;
		// 		doc.text(content68, 15, 145, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Design & Visualization:", 15, 175);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content69 = `
		// ${bulletPoint}  Visual Communication: Translating ideas and information into compelling visuals.

		// ${bulletPoint}  Creativity: Designing innovative graphics, layouts, and presentations.

		// ${bulletPoint}  Attention to Detail: Ensuring accuracy and clarity in visual representations.
		// `;
		// 		doc.text(content69, 15, 180, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 215)
		// 		const content70 = `
		// ${bulletPoint}  Graphic Designer: Creating visual content for marketing materials, websites, and more.

		// ${bulletPoint}  UX/UI Designer: Designing user interfaces and experiences that are intuitive and engaging.

		// ${bulletPoint}  Marketing Specialist: Using visual elements to enhance campaigns and presentations.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content70, 15, 220, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("19", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Design & Visualization:", 15, 25, { maxWidth: 185, align: "justify" })
		// 		const content71 = `
		// ${bulletPoint}  Enhanced Communication: Visuals can simplify complex ideas and improve understanding.

		// ${bulletPoint}  Increased Engagement: Well-designed visuals attract and retain attention, enhancing engagement.

		// ${bulletPoint}  Creativity Expression: Design allows for personal and professional creativity to flourish.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content71, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Social Initiatives and Impact:", 10, 87);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content72 = `
		// Social Initiatives and Impact involve the evaluation of policies and the promotion of particular viewpoints or changes to legislation. These skills are important in roles that intersect with government, non-profits, or large corporations aiming to influence public policy.
		// `;
		// 		doc.text(content72, 15, 92, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Social Initiatives and Impact:", 15, 122);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content73 = `
		// ${bulletPoint}  Research: Conducting thorough research to understand the implications of existing or proposed policies.

		// ${bulletPoint}  Critical Thinking: Analyzing policies from multiple perspectives to determine their impact.

		// ${bulletPoint}  Advocacy: Promoting specific policies or changes to benefit organizations or communities.
		// 		`;
		// 		doc.text(content73, 15, 127, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 182)
		// 		const content74 = `
		// ${bulletPoint}  Policy Analyst: Researching and analyzing policies to inform decision-making.

		// ${bulletPoint}  Advocacy Coordinator: Leading campaigns to promote policy changes on behalf of organizations or causes.

		// ${bulletPoint}  Public Affairs Specialist: Working with government or non-profits to influence public policy.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content74, 15, 187, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Social Initiatives and Impact:", 15, 237)
		// 		const content75 = `
		// ${bulletPoint}  Informed Decision-Making: Strong policy analysis skills support better decision-making.

		// ${bulletPoint}  Influence: Advocacy skills allow you to influence policies that affect your industry or community.

		// ${bulletPoint}  Impact: Effective advocacy can lead to meaningful change and improvements in public policy.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content75, 15, 242, { maxWidth: 185, align: "justify" });
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("20", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Monitoring, Inspecting and Testing:", 10, 25);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content76 = `Monitoring, Inspecting and Testing refers to responsible management and care of the environment, with a focus on sustainability and minimizing environmental impact. This skill is increasingly important in industries seeking to balance profitability with ecological responsibility.`;
		// 		doc.text(content76, 15, 35, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Monitoring, Inspecting and Testing:", 15, 65);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content78 = `
		// ${bulletPoint}  Sustainability: Implementing practices that reduce waste and conserve resources.

		// ${bulletPoint}  Environmental Awareness: Understanding the environmental impact of business operations.

		// ${bulletPoint}  Corporate Social Responsibility (CSR): Engaging in initiatives that promote environmental well-being.
		// `;
		// 		doc.text(content78, 15, 70, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 120)
		// 		const content77 = `
		// ${bulletPoint}  Sustainability Coordinator: Leading initiatives that improve environmental sustainability within an organization.

		// ${bulletPoint}  Environmental Consultant: Advising businesses on how to reduce their environmental footprint.

		// ${bulletPoint}  CSR Manager: Managing corporate social responsibility programs focused on environmental stewardship.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content77, 15, 125, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Monitoring, Inspecting and Testing:", 15, 180)
		// 		const content79 = `
		// ${bulletPoint}  Positive Impact: Monitoring, Inspecting and Testing contributes to the preservation of the environment.

		// ${bulletPoint}  Reputation Enhancement: Organizations with strong environmental practices are viewed more favorably by consumers.

		// ${bulletPoint}  Innovation Opportunities: Monitoring, Inspecting and Testing often leads to innovative approaches that improve both environmental and business outcomes.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content79, 15, 185, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text("Self Management and Development:", 10, 245);
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content80 = `Self Management and Development focus on the continuous acquisition of new knowledge and skills, enablingpersonal and professional growth. This aspect is particularly important in management, where the ability to adapt and stay updated with the latest trends is essential.`;
		// 		doc.text(content80, 15, 255, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("21", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Self Management and Development:", 15, 25);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content81 = `
		// ${bulletPoint}  Continuous Learning: Engaging in lifelong learning through courses, certifications, and professional development.

		// ${bulletPoint}  Skill Enhancement: Actively seeking opportunities to improve and diversify your skill set.

		// ${bulletPoint}  Mentorship: Learning from mentors and, in turn, offering guidance to others.
		// `;
		// 		doc.text(content81, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 80)
		// 		const content82 = `
		// ${bulletPoint}  Training Coordinator: Organizing training sessions and workshops for employees.

		// ${bulletPoint}  Self Management and Development Specialist: Creating programs to foster employee growth and skill development.

		// ${bulletPoint}  Career Coach: Helping others achieve their professional development goals.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content82, 15, 85, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Self Management and Development:", 15, 130)
		// 		const content83 = `
		// ${bulletPoint}  Increased Competency: Continuous learning ensures you remain competitive and up-to-date in your field.

		// ${bulletPoint}  Career Flexibility: A commitment to development opens new career paths and opportunities.

		// ${bulletPoint}  Organizational Value: By constantly enhancing your skills, you increase your value to the organization.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content83, 15, 135, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(22);
		// 		doc.text(`Cross Cultural Engagements:`, 10, 195, { maxWidth: 185, align: "justify" });
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		const content84 = `
		// Cross Cultural Engagements involves building and maintaining relationships with keystakeholders across different regions or countries. This skill  is crucial in global organizations where managing cross-border relationships is key to success.
		// `;
		// 		doc.text(content84, 15, 200, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Key Aspects of Cross Cultural Engagements:", 15, 230);
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.setFont("Kollektif", "normal");
		// 		const content85 = `
		// ${bulletPoint}  Cultural Awareness: Understanding and respecting cultural differences to foster strong relationships.

		// ${bulletPoint}  Strategic Partnerships: Building and managing partnerships with organizations in different regions.

		// ${bulletPoint}  Communication: Effectively communicating across languages and cultural barriers.
		// `;
		// 		doc.text(content85, 15, 235, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("22", 190, 291);
		// 		doc.addPage();
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Vocation", 160, 20);
		// 		doc.setTextColor(255, 0, 0);
		// 		doc.text("IQ", 184, 20);
		// 		doc.setTextColor(37, 96, 205)
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Applicable Roles:", 15, 25)

		// 		const content86 = `
		// ${bulletPoint}  Cross Cultural Engagements Specialist: Creating programs to foster employee growth and skill development.

		// ${bulletPoint}  Training Coordinator: Organizing training sessions and workshops for employees.

		// ${bulletPoint}  Career Coach: Helping others achieve their professional development goals.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content86, 15, 30, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(37, 96, 205);
		// 		doc.setFontSize(16);
		// 		doc.setFont("Kollektif", "bold");
		// 		doc.text("Benefits of Cross Cultural Engagements:", 15, 80)

		// 		const content87 = `
		// ${bulletPoint}  Global Opportunities: Strong relationship management skills open doors to international opportunities.

		// ${bulletPoint}  Cultural Competence: Working across borders enhances your cultural competence and adaptability.

		// ${bulletPoint}  Business Growth: Building international relationships can lead to business expansion and success in new markets.
		// `;
		// 		doc.setFont("Kollektif", "normal");
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.setFontSize(14);
		// 		doc.text(content87, 15, 85, { maxWidth: 185, align: "justify" });
		// 		doc.setTextColor(0, 0, 0);
		// 		doc.line(20, 290, boxX + boxWidth, 290);
		// 		doc.text("23", 190, 291);
		doc.addPage();
		doc.setFontSize(16);
		doc.setFont("Kollektif", "bold");
		doc.text("Vocation", 160, 20);
		doc.setTextColor(255, 0, 0);
		doc.text("IQ", 184, 20);
		doc.setTextColor(37, 96, 205)
		doc.setFontSize(35);
		doc.text(`About
The Company`, 20, 40);
		doc.text(`Vision`, 20, 150);
		doc.text(`Mission`, 20, 210);
		doc.setTextColor(0, 0, 0);
		doc.setFont("Kollektif", "normal");
		doc.setFontSize(16);
		doc.setFillColor(247, 247, 247);
		doc.roundedRect(rectX, rectY, rectWidth + 35, rectHeight + 5, cornerRadius, cornerRadius, 'F');
		doc.text(`Founded by ISB alumna Sindhu VK, VocationIQ leverages her 15+ years of experience in market research, business development, product development, and consulting. Sindhu's diverse professional background and personal career development journey has inspired the creation of our Strengths Analyzer Platform. 
	
Unlike traditional behaviour-based analysis, our platform utilizes an innovative application-based strengths assessment methodology, setting a new standard in the industry.`,
			20, 70, { maxWidth: 175, align: "justify" })
		doc.setFillColor(247, 247, 247);
		doc.roundedRect(rectX, rectY + 100, rectWidth + 30, rectHeight - 40, cornerRadius, cornerRadius, 'F');
		doc.text(`To empower every management student worldwide with the knowledge of their innate strengths, enabling them to realize their full potential and enjoy a satisfying career.`, 20, 170, { maxWidth: 175, align: "justify" })
		doc.setFillColor(247, 247, 247);
		doc.roundedRect(rectX, rectY + 155, rectWidth + 30, rectHeight - 40, cornerRadius, cornerRadius, 'F');
		doc.text(`To provide the Strengths Analyzer Platform to every management student in India, helping them identify their strengths and development areas to make informed upskilling and career choices.`,
			20, 225, { maxWidth: 175, align: "justify" });
		doc.setTextColor(0, 0, 0);
		doc.line(20, 290, boxX + boxWidth, 290);
		doc.text("08", 190, 291);
		doc.addPage();
		doc.setFillColor(37, 96, 205);
		doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'F');
		doc.setFontSize(18);
		doc.setFont('Kollektif', 'bold');
		doc.setTextColor(255, 255, 255)
		doc.text("Vocation", 20, 15)
		doc.setTextColor(255, 0, 0)
		doc.text("IQ", 47.5, 15)
		doc.setTextColor(0, 0, 0)
		doc.addImage(image10, 'PNG', 0, 40, 210, 190);
		doc.setFillColor(247, 247, 247);
		doc.roundedRect(rectX + 20, rectY + 130, rectWidth - 15, rectHeight, cornerRadius, cornerRadius, 'F');
		doc.setTextColor(37, 96, 205)
		doc.setFontSize(18);
		doc.setFont('Kollektif', 'bold');
		doc.text(`Contact Us For Further Inquiries`, 42, 205)
		doc.setTextColor(0, 0, 0)
		doc.text(`Sindhu VK`, 42, 215);
		doc.text(`Founder VocationIQ Technologies.
+91-9844459162
Bangalore, India.`, 42, 225);
		doc.line(20, 290, boxX + boxWidth, 290);
		doc.text("09", 190, 291);
		const pdfBlob = doc.output('blob');
		const testId = new Date().toISOString().replace(/[:.]/g, '-');
		const storagePath = `pdfs/${userUid}/${testId}.pdf`;

		// Reference Firebase Storage
		const pdfRef = storageRef(storage, storagePath);
		await uploadBytes(pdfRef, pdfBlob)
			.then(async (snapshot) => {


				const downloadURL = await getDownloadURL(pdfRef);

				const pdfURLRef = ref(db, `${getCollegeName()}/Reports/${userUid}`);
				await set(pdfURLRef, {
					dateTaken: new Date().toISOString(),
					downloadURL
				});

			})
			.catch((error) => {
				console.error('Error uploading PDF:', error);
			});
		doc.save(`${userName} Strengths Analyzer Report.pdf`);
		setLoading(false);
	}
	let row1 = [];
	let structuredData = [];
	const logCollectiveScoreRangeStatement = () => {
		addResponsesToArray(userUid);
		const minScore = Math.min(...sortedYo.map((item) => item.normalizedScore));
		const maxScore = Math.max(...sortedYo.map((item) => item.normalizedScore));

		// Handle edge cases where minScore or maxScore are invalid
		if (minScore === Infinity || maxScore === -Infinity) {
			console.error("Invalid score values found in sortedYo");
			return;
		}

		const rankMap = {};

		if (minScore >= 0 && maxScore <= 2.5) {
			row1 = [
				...sortedYo.map((item, index) => {
					const type = getLowerType(item.score, sortedYo);
					if (!rankMap[type]) {
						rankMap[type] = 1;
					} else {
						rankMap[type]++;
					}
					structuredData[item.key] = {
						type: type,
						rank: rankMap[type],
					};
					return [item.key, type, `${rankMap[type]}`];
				}),
				...missingElements.map((item, index) => {
					structuredData[item] = {
						type: 'Unexplored',
						rank: 0,
					};
					return [item, 'Unexplored', 0];
				}),
			];
		} else if (minScore > 2.5 && maxScore <= 5) {
			row1 = [
				...sortedYo.map((item, index) => {
					const type = getUpperType(item.score, sortedYo);
					if (!rankMap[type]) {
						rankMap[type] = 1;
					} else {
						rankMap[type]++;
					}
					structuredData[item.key] = {
						type: type,
						rank: rankMap[type],
					};

					return [item.key, type, `${rankMap[type]}`];
				}),
				...missingElements.map((item, index) => {
					structuredData[item] = {
						type: 'Unexplored',
						rank: 0,
					};
					return [item, 'Unexplored', 0];
				}),
			];
		} else if (minScore >= 0 && maxScore <= 5) {
			row1 = [
				...sortedYo.map((item, index) => {
					const type = getNormalType(item.score, sortedYo);
					if (!rankMap[type]) {
						rankMap[type] = 1;
					} else {
						rankMap[type]++;
					}
					structuredData[item.key] = {
						type: type,
						rank: rankMap[type],
					};

					return [item.key, type, `${rankMap[type]}`];
				}),
				...missingElements.map((item, index) => {
					structuredData[item] = {
						type: 'Unexplored',
						rank: 0,
					};
					return [item, 'Unexplored', 0];
				}),
			];
		} else {
			console.log('Invalid collective score range');
		}
	};

	res = structuredData;
	const sortedYo = [...yo].sort((a, b) => b.score - a.score);
	logCollectiveScoreRangeStatement();

	const headers = ['Skills', 'Rank'];

	const groupedData = row1.reduce((acc, [skill, type, rank]) => {
		if (!acc[type]) {
			acc[type] = [];
		}
		acc[type].push({ skill, rank });
		return acc;
	}, {});


	Object.keys(res).forEach(skill => {
		const skillDetails = res[skill];
		if (skillDetails.type === "Exceptional") {
			exceptionalArr.add(skill);
		}
		else if (skillDetails.type === "Strengths") {
			strengthsArr.add(skill);
		}
		else if (skillDetails.type === "Opportunities") {
			opportunitiesArr.add(skill);
		}
		else if (skillDetails.type === "Could be Improved") {
			couldBeImprovedArr.add(skill);
		}
		else if (skillDetails.type === "Needs Improvement") {
			needsImprovementArr.add(skill);
		}
		else if (skillDetails.type === "Unexplored") {
			unexploredArr.add(skill);
		}
	});

	const couldBeImprovedArray = Array.from(couldBeImprovedArr);
	const needsImprovementArray = Array.from(needsImprovementArr);
	const unexploredArray = Array.from(unexploredArr);
	const opportunitiesArray = Array.from(opportunitiesArr);
	const strengthsArray = Array.from(strengthsArr);
	const exceptionalArray = Array.from(exceptionalArr);
	const workinProgressArray = Array.from(workinProgressArr);
	if (couldBeImprovedArray.length === 1) {
		couldBeImprovedSkills = couldBeImprovedArray[0];
	} else if (couldBeImprovedArray.length === 2) {
		couldBeImprovedSkills = couldBeImprovedArray.join(' and ');
	} else if (couldBeImprovedArray.length > 2) {
		couldBeImprovedSkills = couldBeImprovedArray.slice(0, -1).join(', ') + ', and ' + couldBeImprovedArray.slice(-1);
	} else {
		couldBeImprovedSkills = '';
	}
	if (needsImprovementArray.length === 1) {
		needsImprovementSkills = needsImprovementArray[0];
	} else if (needsImprovementArray.length === 2) {
		needsImprovementSkills = needsImprovementArray.join(' and ');
	} else if (needsImprovementArray.length > 2) {
		needsImprovementSkills = needsImprovementArray.slice(0, -1).join(', ') + ', and ' + needsImprovementArray.slice(-1);
	} else {
		needsImprovementSkills = '';
	}
	if (unexploredArray.length === 1) {
		unexploredSkills = unexploredArray[0];
	} else if (unexploredArray.length === 2) {
		unexploredSkills = unexploredArray.join(' and ');
	} else if (unexploredArray.length > 2) {
		unexploredSkills = unexploredArray.slice(0, -1).join(', ') + ', and ' + unexploredArray.slice(-1);
	} else {
		unexploredSkills = '';
	}
	if (opportunitiesArray.length === 1) {
		opportunitiesSkills = opportunitiesArray[0];
	} else if (opportunitiesArray.length === 2) {
		opportunitiesSkills = opportunitiesArray.join(' and ');
	} else if (opportunitiesArray.length > 2) {
		opportunitiesSkills = opportunitiesArray.slice(0, -1).join(', ') + ', and ' + opportunitiesArray.slice(-1);
	} else {
		opportunitiesSkills = '';
	}
	if (strengthsArray.length === 1) {
		strengthsSkills = strengthsArray[0];
	} else if (strengthsArray.length === 2) {
		strengthsSkills = strengthsArray.join(' and ');
	} else if (strengthsArray.length > 2) {
		strengthsSkills = strengthsArray.slice(0, -1).join(', ') + ', and ' + strengthsArray.slice(-1);
	} else {
		strengthsSkills = '';
	}
	if (exceptionalArray.length === 1) {
		exceptionalSkills = exceptionalArray[0];
	} else if (exceptionalArray.length === 2) {
		exceptionalSkills = exceptionalArray.join(' and ');
	} else if (exceptionalArray.length > 2) {
		exceptionalSkills = exceptionalArray.slice(0, -1).join(', ') + ', and ' + exceptionalArray.slice(-1);
	} else {
		exceptionalSkills = '';
	}
	if (workinProgressArray.length === 1) {
		workinProgressSkills = workinProgressArray[0];
	} else if (workinProgressArray.length === 2) {
		workinProgressSkills = workinProgressArray.join(' and ');
	} else if (workinProgressArray.length > 2) {
		workinProgressSkills = workinProgressArray.slice(0, -1).join(', ') + ', and ' + workinProgressArray.slice(-1);
	} else {
		workinProgressSkills = '';
	}

	const calculateCategoryPercentages = (categories, yo) => {
		for (const category in categories) {
			if (!Array.isArray(categories[category])) continue;
			let totalScore = 0;
			let skillCount = 0;
			categories[category].forEach(skill => {
				const skillData = yo.find(item => item.questions === skill);
				if (skillData) {
					totalScore += skillData.score;
				}
				skillCount++;
			});

			const averageScore = skillCount > 0 ? (totalScore / skillCount) * 100 : 0;
			categories[`percentage${category}`] = Math.round(averageScore);
		}
	};

	const calculateTargetJobPercentages = (categories, yo) => {
		for (const category in categories) {
			if (!categories[category].skill) {
				continue;
			}

			const skills = categories[category].skill;
			let totalScore = 0;
			let skillCount = 0;

			skills.forEach(skill => {
				const skillData = yo.find(item => item.questions === skill);
				if (skillData) {
					totalScore += skillData.score;
				}
				skillCount++;
			});

			const averageScore = skillCount > 0 ? (totalScore / skillCount) * 100 : 0;
			categories[category].percentage = Math.round(averageScore);
		}
	};

	calculateCategoryPercentages(categories, yo);
	calculateCategoryPercentages(softSkill, yo);
	calculateTargetJobPercentages(targetJobs, yo);

	let targetJobsArray = Object.entries(targetJobs);

	targetJobsArray.sort((a, b) => b[1].percentage - a[1].percentage);

	totTeamIndivisual = counts.countI + counts.countT + counts.countTI;
	percentageI = (counts.countI / totTeamIndivisual) * 100;
	percentageT = (counts.countT / totTeamIndivisual) * 100;
	percentageTI = (counts.countTI / totTeamIndivisual) * 100;
	const renderTable = (type, data) => (
		<TableContainer component={Paper} style={{ borderRadius: '12px', fontFamily: 'Poppins, sans-serif', margin: '10px', flex: '1 1 45%' }}>
			<Typography variant="h6" style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, marginBottom: '10px', marginTop: '20px' }}>
				{type}
			</Typography>
			<Table>
				<TableHead style={{ background: '#2560CD' }}>
					<TableRow>
						{headers.map((header) => (
							<TableCell key={header} style={{
								color: 'white',
								fontFamily: 'Poppins, sans-serif',
								fontWeight: 500,
								fontSize: '15px',
								border: '1px solid white',
							}}>
								{header}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{data.map(({ skill, rank }, index) => (
						<TableRow key={index} style={{ fontFamily: 'Poppins, sans-serif' }}>
							<TableCell style={{ border: "1px solid GrayText" }}>{skill}</TableCell>
							<TableCell style={{ border: "1px solid GrayText" }}>
								<CircleIcon color={getColor(type)} fontSize="small" /> {rank}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer >
	);

	const groupedTypes = Object.keys(groupedData);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
			{groupedTypes.map((type, index) => {
				if (index % 2 === 0) {
					return (
						<div key={index} style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
							{renderTable(groupedTypes[index], groupedData[groupedTypes[index]])}
							{groupedTypes[index + 1] && renderTable(groupedTypes[index + 1], groupedData[groupedTypes[index + 1]])}
						</div>
					);
				}
				return null;
			})}
			<GenerateButton onClick={handlenewpdf} disabled={loading}> {loading ? 'Loading...' : 'Download Detailed Report'}{loading && (
				<CircularProgress size={24} style={{ marginLeft: '10px', color: 'white' }} />
			)}</GenerateButton>
		</div>
	);
};

export { res };
export default ViewResult;
